import { useState, useEffect, useRef } from 'react';

import { useIsFetching } from '@gogame/query';

import { grids } from './queryKeyFactory';

const DELAY = 16 * 1000;

export const useIsLongLoading = () => {
  const fetching = useIsFetching([...grids(), 0]);
  const [long, setLong] = useState(false);
  const timeoutIdRef = useRef(null);

  useEffect(() => {
    if (fetching) {
      timeoutIdRef.current = setTimeout(() => {
        setLong(true);
      }, DELAY);
    } else {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    }
    return () => setLong(false);
  }, [fetching]);

  return !!fetching && long;
};
